var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * LockUnlocked component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconLockUnlocked extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.379 1.57647C13.6249 1.262 12.8154 1.10175 11.9984 1.10516C10.3513 1.1056 8.77172 1.7601 7.60701 2.92481C6.4419 4.08991 5.78735 5.67013 5.78735 7.31783V8.90881H5.75705C4.48085 8.90881 3.44629 9.94338 3.44629 11.2196V20.5842C3.44629 21.8604 4.48085 22.8949 5.75705 22.8949H18.2432C19.5194 22.8949 20.5539 21.8604 20.5539 20.5842V11.2196C20.5539 9.94338 19.5194 8.90881 18.2432 8.90881H7.28735V7.31783C7.28735 6.06795 7.78387 4.86927 8.66767 3.98547C9.55146 3.10167 10.7502 2.60516 12 2.60516L12.0034 2.60515C12.6205 2.60241 13.232 2.72338 13.8017 2.96092C14.3713 3.19847 14.8876 3.54776 15.3199 3.98817C15.6101 4.28375 16.085 4.28812 16.3806 3.99793C16.6761 3.70774 16.6805 3.23289 16.3903 2.93731C15.8175 2.35388 15.1336 1.89116 14.379 1.57647ZM6.52133 10.4088L6.53735 10.409L6.55338 10.4088H18.2432C18.6909 10.4088 19.0539 10.7718 19.0539 11.2196V20.5842C19.0539 21.0319 18.6909 21.3949 18.2432 21.3949H5.75705C5.30928 21.3949 4.94629 21.0319 4.94629 20.5842V11.2196C4.94629 10.7718 5.30928 10.4088 5.75705 10.4088H6.52133ZM12.0001 14.3716C11.1549 14.3716 10.4697 15.0568 10.4697 15.902C10.4697 16.7472 11.1549 17.4324 12.0001 17.4324C12.8453 17.4324 13.5305 16.7472 13.5305 15.902C13.5305 15.0568 12.8453 14.3716 12.0001 14.3716Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconLockUnlocked.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconLockUnlocked.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconLockUnlocked.prototype, "size", void 0);
if (customElements.get('cat-icon-lock-unlocked') === undefined) {
    customElements.define('cat-icon-lock-unlocked', BlocksIconLockUnlocked);
}
